<template>
  <div class="row">
    <div class="col-xl-2 col-lg-2 col-xxxl-2 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-sun-horizon"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                AM
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ getDashboardDayCards.am }}
              </h4>
              <span class="fw-medium text-dark-emphasis">
                00:00 - 12:00
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-2 col-lg-2 col-xxxl-2 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-cloud-moon"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                PM
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ getDashboardDayCards.pm }}
              </h4>
              <span class="fw-medium text-dark-emphasis">
                12:01 - 23:59
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-2 col-lg-2 col-xxxl-2 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-cassette-tape"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Tempo médio de gravação
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ convertTime(getDashboardDayCards.average_time) }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-2 col-lg-2 col-xxxl-2 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-file-audio"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Tamanho médio de arquivo
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ (getDashboardDayCards.average_size / (1024 * 1024)).toFixed(2) + " MB" }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-2 col-lg-2 col-xxxl-2 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-calendar-blank"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Comparado a ontem
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ getDashboardDayCards.compared_to_yesterday }}%
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-2 col-lg-2 col-xxxl-2 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-soundcloud-logo"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Maior gravação do dia
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ convertTime(getDashboardDayCards.bigger_time) }}
              </h4>
              <span class="fw-medium text-dark-emphasis">
                {{ (getDashboardDayCards.bigger_size / (1024 * 1024)).toFixed(2) + " MB" }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "DashboardCardsTodayInformations",
  data() {
    return {};
  },
  computed:{
    ...mapGetters([
      'getDashboardDayCards'
    ])
  },
  methods: {
    convertTime(time){
      return moment.utc(time*1000).format('HH:mm:ss');
    }
  },
});
</script>